module.exports = __webpack_public_path__ + "img/quanta-shop-branca.b701cc1c.png";